import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  peliculas: [],
};

const favoritosSlice = createSlice({
  name: "favoritos",
  initialState,
  reducers: {
    agregarPelicula: (state, action) => {
      console.log("Película añadida:", action.payload);
      state.peliculas.push(action.payload);
    },
    eliminarPelicula: (state, action) => {
      console.log("Película eliminada:", action.payload);
      state.peliculas = state.peliculas.filter(
        (pelicula) => pelicula.id !== action.payload.id
      );
    },
  },
});

export const { agregarPelicula, eliminarPelicula } = favoritosSlice.actions;
export default favoritosSlice.reducer;
